export default __webpack_public_path__ + "static/media/leslie_samuel.57bc85e4.png";